/** E4 §4.1 · 聊天模式是否可用（D16 + D17）。
 *
 * 可用 = 租戶已核准「AI 聊天助手」訂閱，且本人未被租戶管理員停用。
 * 來源：後端 GET /api/system/my-modes（AuthContext 隨使用者載入一次，存共用 context，不重複打）。
 * 不看角色權限、不看 enabled_ui_modes。
 */
import { useAuth } from '../contexts/AuthContext';

export const useChatModeAvailable = (): boolean => useAuth().chatModeAvailable;
